import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchAudiences(payload) {
  return { type: actionTypes.FETCH_AUDIENCES, payload }
}

export function fetchAudiencesSuccess(payload) {
  const byId = keyBy(payload, (aud) => aud.AUDIENCE_TYPE_ID);
  return { type: actionTypes.FETCH_AUDIENCES_SUCCESS, payload: { byId } };
}